import * as React from "react";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";
import { registrationActions } from "../store/registrationSlice";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useFetch } from "../hooks/useFetch";
import { useEffect } from "react";
import moment from "moment";

export default function Review() {
  const dispatch = useDispatch();
  const bookingDetails = useSelector(
    (state) => state.registration.bookingDetails
  );
  const activeStep = useSelector((state) => state.registration.activeStep);
  const steps = useSelector((state) => state.registration.steps);

  const [bookingDetailsState, setBookingDetailsState] =
    React.useState(bookingDetails);

  const [promoCode, setPromoCode] = React.useState("");
  const [promoCodeWorking, setPromoCodeWorking] = React.useState(false);
  const [discount, setDiscount] = React.useState(0);

  const { postData, data, error } = useFetch(
    "https://cuddly-purple-settee.glitch.me/api/payment",
    "POST"
  );

  const handlePayment = async () => {
    // alert(JSON.stringify(bookingDetails));
    postData({ bookingDetails });
  };

  const handleBack = () => {
    dispatch(registrationActions.setActiveStep(0));
  };

  // Check validity of promo code, if valid, apply discount to total price
  const handlePromoCode = () => {
    if (promoCode === "Mofun5") {
      dispatch(
        registrationActions.setDiscount({
          ...bookingDetails,
          // Discount code for stripe to apply
          promoCode: "Pa0TAYLY",
        })
      );

      const discount =
        ((bookingDetails.product.Price / 100) * bookingDetails.quantity + 1.5) *
        0.1;

      // Update discount state
      setDiscount(discount);
      setPromoCodeWorking(true);
      alert("Promo code applied!");
    } else {
      alert("Invalid promo code!");
    }
  };

  useEffect(() => {
    if (data) {
      window.location.href = data.url;
    }
    if (error) {
      console.log(error);
      if (!alert("All Tickets are sold out, please try another timeslot")) {
        window.location.href = "/";
      }
    }
  }, [data, error]);

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Order summary
      </Typography>
      <List disablePadding>
        <ListItem sx={{ py: 1, px: 0 }}>
          <ListItemText
            primary={`${bookingDetails.product.Name} - ${bookingDetails.location}`}
            secondary={bookingDetails.product.Description}
          />
          <Typography variant="body2">
            ${(bookingDetails.product.Price / 100).toFixed(2)}
          </Typography>
        </ListItem>

        <ListItem sx={{ py: 1, px: 0 }}>
          <ListItemText primary="Quantity" />
          <Typography variant="body2">x {bookingDetails.quantity}</Typography>
        </ListItem>

        <ListItem sx={{ py: 1, px: 0 }}>
          <ListItemText primary="Booking Fee" />
          <Typography variant="body2">$1.50</Typography>
        </ListItem>

        {promoCodeWorking ? (
          <ListItem sx={{ py: 1, px: 0 }}>
            <ListItemText primary="Discount" />
            <Typography variant="body2">${discount.toFixed(2)}</Typography>
          </ListItem>
        ) : null}

        <ListItem sx={{ py: 1, px: 0 }}>
          <ListItemText primary="Total" />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            $
            {(
              (bookingDetails.product.Price / 100) * bookingDetails.quantity +
              1.5 -
              discount
            ).toFixed(2)}
          </Typography>
        </ListItem>

        <Grid container spacing={0} sx={{ mb: 1, alignItems: "center" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              // Make text field shorter

              id="promoCode"
              name="promoCode"
              label="Promo Code"
              autoComplete="promoCode"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
            />
          </Grid>

          {/*Button to apply promo code*/}

          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                handlePromoCode();
              }}
            >
              Apply
            </Button>
          </Grid>
        </Grid>
      </List>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
            Particulars
          </Typography>
          <Typography gutterBottom>
            {bookingDetails.firstName} {bookingDetails.lastName}
          </Typography>
          <Typography gutterBottom>{bookingDetails.contact}</Typography>
          <Typography gutterBottom>{bookingDetails.email}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
            Booking Details
          </Typography>
          <Typography gutterBottom>
            {moment(bookingDetails.date).format("LL")}
          </Typography>
          <Typography gutterBottom>{bookingDetails.timeslot}</Typography>
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        {activeStep !== 0 && (
          <Button onClick={() => handleBack()} sx={{ mt: 3, ml: 1 }}>
            Back
          </Button>
        )}

        <Button
          variant="contained"
          onClick={handlePayment}
          sx={{ mt: 3, ml: 1 }}
        >
          {activeStep === steps.length - 1 ? "Pay" : "Next"}
        </Button>
      </Box>
    </>
  );
}
